export default __webpack_public_path__ + "1188e73fda9f0d049dfd32cf6413cf67.svg";